import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './Button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'soft' | 'ghost' | 'dashed';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  type?: 'button' | 'submit';
  children: ReactNode;
}

// PARA-120 — общий примитив кнопки (по образцу etc/design-system/project/components/primitives/Button.jsx).
// Намеренно нет "деструктивного" варианта — тон дизайн-системы "заботливый напарник" (AC-3).
export function Button({
  variant = 'primary',
  fullWidth = false,
  type = 'button',
  className,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  const classes = [styles.button, styles[variant], fullWidth ? styles.fullWidth : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
